module.exports = __webpack_public_path__ + "static/media/Timer.8b7e709e.svg";